import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNAButton, luxColors, } from '@alucio/lux-ui';
import { SideBarOption } from './Menu';
import { useMeetingControls } from '../../../../src/hooks/useMeetingControls/useMeetingControl';
import SettingPopOverDialog from './SettingPopOverDialog';
import { MODE_TYPE } from '../../../main';
const styles = StyleSheet.create({
    endMenu: {
        borderColor: luxColors.contentPanelBackground.tertiary,
        backgroundColor: luxColors.contentPanelBackground.primary,
        padding: 12,
        borderWidth: 2,
        width: 190,
    },
});
const PopOverEndCall = (props) => {
    const { mode } = useMeetingControls();
    const [endCallToggle, setEndCallToggle] = useState(false);
    return (React.createElement(SettingPopOverDialog, { key: props.title, visible: endCallToggle, onPress: () => setEndCallToggle(!endCallToggle), onClose: () => setEndCallToggle(false) },
        React.createElement(SettingPopOverDialog.Anchor, null,
            React.createElement(SideBarOption, { menuOption: props, onSelectedOption: () => setEndCallToggle((p) => !p) })),
        React.createElement(SettingPopOverDialog.Content, null,
            React.createElement(DNABox, { appearance: "col", style: styles.endMenu, spacing: "small" },
                React.createElement(DNAButton, { status: "danger", style: { flex: 1 }, onPress: () => {
                        setEndCallToggle((p) => !p);
                        props.onSelectedOption(props);
                    } }, mode === MODE_TYPE.HOST ? 'End meeting' : 'Leave meeting'),
                React.createElement(DNAButton, { status: "flat", style: { flex: 1 }, onPress: () => setEndCallToggle((p) => !p) }, "Cancel")))));
};
export default PopOverEndCall;
//# sourceMappingURL=EndMeeting.js.map